import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";

const DriveAnalyticsPdf = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [city, setCity] = useState([]);
  const [totalDistance, settotalDistance] = useState([]);
  const [totalVehCount, settotalVehCount] = useState([]);
  const [medianRange, setMedianRange] = useState();
  const [medianSoc, setMedianSoc] = useState();
  const [medianDistanceInKm, setMedianDistanceInKm] = useState();
  const [medianNetKwh, setMedianNetKwh] = useState();
  const [medianWhPerKm, setMedianWhPerKm] = useState();
  const [airVentilation, setAirVentilation] = useState();
  const [PLValue, setPLValue] = useState([]);
  const [drivenCount, setDrivenCount] = useState();
  const [totalCount, setTotalCount] = useState();

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/secondpagepdf",
        body: { filterdata: gloablfilter },
      },
      tablefunc
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/secondpage_total_count_pdf",
        body: { filterdata: gloablfilter },
      },
      tablecountfunc
    );
  }, [gloablfilter]);
  // Expose method through useImperativeHandle to parent component
  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      city,
      totalDistance,
      totalVehCount,
      medianRange,
      medianSoc,
      medianDistanceInKm,
      medianNetKwh,
      medianWhPerKm,
      airVentilation,
      PLValue,
      drivenCount,
      totalCount,
    }),
  }));
  const tablecountfunc = (data) => {
    setTotalCount(data);
  };

  const tablefunc = (data) => {
    setCity(data.uniqueCities);
    settotalDistance(
      data.totaldistance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );
    settotalVehCount(data.totalvehcount);
    setMedianRange(data.cityMedianValues);
    setMedianSoc(data.cityMedian_dischargeSocValues);
    setMedianDistanceInKm(data.citydistanceInKMValues);
    setMedianNetKwh(data.cityMedian_NetkWhValues);
    setMedianWhPerKm(data.citymedian_whPerKMValues);
    setAirVentilation(data.cityAirVentilationValues);
    // setPLValue(data.cityPLValues);
    setPLValue(data.PLval);
    setDrivenCount(data.total_vehicle_count);
  };

  const calculateMedian = (values) => {
    if (!values || values.length === 0) return null;
    values = values.map(Number).sort((a, b) => a - b);
    const mid = Math.floor(values.length / 2);
    // return values.length % 2 !== 0 ? values[mid] : (values[mid - 1] + values[mid]) / 2;
    const median =
      values.length % 2 !== 0
        ? values[mid]
        : (values[mid - 1] + values[mid]) / 2;
    return median.toFixed(2);
  };

  // const medianValues = city.reduce((acc, cityName) => {
  //   acc[cityName] = calculateMedian(medianDistanceInKm[cityName]);
  //   return acc;
  // }, {});

  // const medianSocValues = city.reduce((acc, cityName) => {
  //   acc[cityName] = calculateMedian(medianRange[cityName]);
  //   return acc;
  // }, {});

  // const medianDistanceValues = city.reduce((acc, cityName) => {
  //   acc[cityName] = calculateMedian(medianWhPerKm[cityName]);
  //   return acc;
  // }, {});

  // const medianNetKwhValues = city.reduce((acc, cityName) => {
  //   acc[cityName] = calculateMedian(medianNetKwh[cityName]);
  //   return acc;
  // }, {});
  // const medianWhPerKmValues = city.reduce((acc, cityName) => {
  //   acc[cityName] = calculateMedian(medianSoc[cityName]);
  //   return acc;
  // }, {});

  const medianSocValues = PLValue.length
    ? PLValue.reduce((acc, cityName) => {
        acc[cityName] = calculateMedian(medianRange[cityName]);
        return acc;
      }, {})
    : {};

  const medianDistanceValues = PLValue.length
    ? PLValue.reduce((acc, cityName) => {
        acc[cityName] = calculateMedian(medianWhPerKm[cityName]);
        return acc;
      }, {})
    : {};

  const medianNetKwhValues = PLValue.length
    ? PLValue.reduce((acc, cityName) => {
        acc[cityName] = calculateMedian(medianNetKwh[cityName]);
        return acc;
      }, {})
    : {};

  const medianWhPerKmValues = PLValue.length
    ? PLValue.reduce((acc, cityName) => {
        acc[cityName] = calculateMedian(medianSoc[cityName]);
        return acc;
      }, {})
    : {};

  return (
    <div className="secondpage">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-3">
        <div className="col-md-6">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Drive Analytics:{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      <div
        className="row mt-3"
        style={{ marginLeft: "20px", marginRight: "20px" }}
      >
        {isLoading ? (
          <ChartLoader />
        ) : Object.keys(city).length > 0 ? (
          <table
            className="pdftable"
            style={{ color: "black", font: "12px", fontSize: "large" }}
          >
            <tr style={{ backgroundColor: "#d9d9d9" }}>
              <th></th>
              {Object.values(city).map((cityName, index) => (
                <th key={index}>{cityName}</th>
              ))}
            </tr>
            {/* <tr>
              <td>Vehicle Type</td>
              {city.map((cityName, index) => (
                <td key={index}>{(PLValue[cityName])}</td>
              ))}
            </tr> */}
            <tr style={{ backgroundColor: "#d9d9d9" }}>
              <td>Vehicle Type</td>
              {PLValue.map((cityName, index) => {
                const value = PLValue[index];
                const stringValue =
                  typeof value === "string" ? value : String(value || "");
                return (
                  <td key={index}>
                    {stringValue.match(/[\d/]+/g)?.join("") || ""}
                  </td>
                );
              })}
            </tr>

            <tr style={{ backgroundColor: "#d9d9d9" }}>
              <td>Drive Analytics</td>
              {PLValue.map((cityName, index) => (
                <td key={index}>{airVentilation[cityName]}</td>
              ))}
            </tr>
            {/* <tr>
              <td>Total Vehicle</td>
              {city.map((cityName, index) => (
                <td key={index}>{totalCount[cityName]}</td>
              ))}
            </tr> */}
            <tr>
              <td>Total|Driven Vehicle </td>
              {PLValue.map((plItem, index) => {
                // Extract city and PL from PLValue item
                const [city, PL] = plItem.split("_"); // Assuming PLValue items are formatted as "City_PL"
                // Find corresponding entry in totalCount
                const entry = totalCount.find(
                  (item) => item.key.DLR_ORG_CITY === city && item.key.PL === PL
                );
                // Display total_vehicle_count if found, otherwise show a placeholder
                const totalVehicleCount = entry
                  ? entry.total_vehicle_count.value
                  : "-";
                return (
                  <td key={index}>
                    {totalVehicleCount} | {drivenCount[plItem]}
                  </td>
                );
              })}
            </tr>
            <tr>
              <td>Total km travelled </td>
              {PLValue.map((cityName, index) => (
                <td key={index}>{medianDistanceInKm[cityName]} km</td>
              ))}
            </tr>
            <tr>
              <td>Median Range (for 80% discharge)</td>
              {PLValue.map((cityName, index) => (
                <td key={index}>{medianSocValues[cityName]} km</td>
              ))}
            </tr>
            <tr>
              <td>Median kWh/km</td>
              {PLValue.map((cityName, index) => (
                <td key={index}>{medianDistanceValues[cityName]} kWh/km</td>
              ))}
            </tr>
            <tr>
              <td>Median Net Consumption/cycle</td>
              {PLValue.map((cityName, index) => (
                <td key={index}>{medianNetKwhValues[cityName]} kWh</td>
              ))}
            </tr>
            <tr>
              <td>Avg Discharge/Cycle </td>
              {PLValue.map((cityName, index) => (
                <td key={index}>{medianWhPerKmValues[cityName]} %</td>
              ))}
            </tr>
          </table>
        ) : (
          <div className="no_data">
            <NoData />
          </div>
        )}
      </div>

      <div
        className="row mt-4"
        style={{ color: "black", paddingLeft: "35px", fontSize: "16px" }}
      >
        {" "}
        • Total {totalVehCount} driven buses are on road with {totalDistance}{" "}
        cumulative kms logged.
      </div>

      <div className="row bottomcontent pl-4" style={{ paddingTop: "350px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
});
export default DriveAnalyticsPdf;
